import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=4ae51e6a&scoped=true"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"
import style0 from "./Historic.vue?vue&type=style&index=0&id=4ae51e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae51e6a",
  null
  
)

export default component.exports